var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarDelete(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 3v1h4V3c0-.531.437-1 1-1 .531 0 1 .47 1 1v1h1.5c.812 0 1.5.688 1.5 1.5V7H3V5.5A1.5 1.5 0 014.5 4H6V3c0-.531.437-1 1-1 .531 0 1 .47 1 1zM3 8h14v8.5a1.5 1.5 0 01-1.5 1.5h-11A1.48 1.48 0 013 16.5V8zm9.5 3.531c.312-.28.312-.75 0-1.062a.736.736 0 00-1.031 0L10 11.969l-1.5-1.5a.736.736 0 00-1.031 0c-.313.312-.313.781 0 1.062L8.937 13l-1.468 1.469c-.313.312-.313.781 0 1.062a.684.684 0 001.03 0l1.5-1.468 1.47 1.468a.685.685 0 001.03 0c.313-.281.313-.75 0-1.062l-1.468-1.47 1.469-1.468z",
    fill: "#0D2976"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarDelete);
export default ForwardRef;